export default __webpack_public_path__ + "static/media/photo6.2b9e4050.jpeg";